import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { OrderAccountForDropdown } from '../../api/models';

export type TABLE_TYPE = Table<OrderAccountForDropdown>;

export const TABLE = 'orderAccountsForDropdown';
const SCHEMA = 'id, sortId';

class OrderAccountsForDropdownDatabase implements DataRepository<OrderAccountForDropdown> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<OrderAccountForDropdown | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: OrderAccountForDropdown, key: Key): Promise<OrderAccountForDropdown> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: OrderAccountForDropdown[]): Promise<OrderAccountForDropdown[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<OrderAccountForDropdown[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const OrderAccountsForDropdownDB = new OrderAccountsForDropdownDatabase(db);
